import { Button } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import themeColorsDesingSystem from "assets/theme/ds-colors";

const useStyles = makeStyles(() => ({
  buttonStyle: {
    border: `1px solid ${themeColorsDesingSystem.stone.dark}`,
    background: "transparent",
    color: themeColorsDesingSystem.stone.dark,
    "&:hover": {
      color: themeColorsDesingSystem.stone.light,
      background: themeColorsDesingSystem.stone.dark,
    },
    "&:disabled": {
      opacity: "0.5",
      cursor: "not-allowed",
      textDecoration: "none",
      color: themeColorsDesingSystem.stone.medium,
      border: `1px solid ${themeColorsDesingSystem.stone.medium}`,
    },
  },
}));

export default function DesignSystemButton({ children, disable, onClick, fullWidth }) {
  const classes = useStyles();

  return (
    <Button
      type="button"
      onClick={onClick}
      disabled={disable}
      className={classes.buttonStyle}
      style={{ width: fullWidth ? "100%" : "auto" }}
    >
      {children}
    </Button>
  );
}
